export default class RepeatedTask {

	constructor(taskId, delay, callback) {
		this.delay = delay;
		this.callback = callback || function(){};
		this.repeatedTaskId = `vtOutagesRepeatedTask_${taskId}`;
		this.launchRepeatedTask();
	}

	launchRepeatedTask() {
		clearInterval(window[this.repeatedTaskId]);
		window[this.repeatedTaskId] = setInterval(this.callback, this.delay);
	}

	cancel() {
		clearInterval(window[this.repeatedTaskId]);
	}
}
